<template>
  <v-form @submit.prevent="submitForm">
    <v-text-field
      v-model="email"
      label="Váš e-mail"
      outlined
      dense
      :error-messages="getViolation('email')"
    ></v-text-field>

    <v-btn
      type="submit"
      depressed
      color="#f6f6f6"
      :disabled="disabled"
      :loading="loading"
    >
      Odebírat
    </v-btn>
    <div class="terms">
      <v-checkbox
        v-model="terms"
        :true-value="true"
        :false-value="false"
        :error-messages="getViolation('terms')"
      ></v-checkbox>
      <small>Souhlasím se <a
          href="/gdpr"
          target="_blank"
        >zpracováním osobních údajů</a>.</small>
    </div>

    <!-- dialog visible after submit -->
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
    >
      <v-card flat>
        <v-card-title>Potvrzení</v-card-title>
        <v-card-text class="">Potvrďte odběr novinek kliknutím na odkaz v e-mailu, který byl odeslán na zadanou adresu.</v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="dialog = false"
          >Zavřít</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import Axios from '../../js/ajax'
import Qs from 'qs'
import { errorHandlerMixin } from '../../js/errorHandlerMixin'

export default {
  name: 'VFormNewsletter',
  mixins: [
    errorHandlerMixin
  ],
  data () {
    return {
      email: null,
      terms: false,
      loading: false,
      dialog: false
    }
  },
  computed: {
    disabled () {
      return this.terms === false
    }
  },
  methods: {
    submitForm () {
      this.loading = true
      Axios.post('/prihlaseni-nesletteru', Qs.stringify({
        email: this.email
      })).then(() => {
        this.dialog = true
        this.email = null
      }).catch((err) => {
        this.buildViolations(err.response)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
